import React, { useState } from "react";

function NeedsObjectives({ onNext, onBack }) {
  const [objectives, setObjectives] = useState("");

  const handleContinue = () => {
    onNext({ objectives });
  };

  return (
    <div>
      <h2>Needs & Objectives</h2>
      <textarea
        value={objectives}
        onChange={(e) => setObjectives(e.target.value)}
        placeholder="E.g. First home, refinance for lower rate, renovations..."
      />
      <br />
      <button onClick={onBack}>⬅️ Back</button>
      <button onClick={handleContinue}>Continue ➡️</button>
    </div>
  );
}

export default NeedsObjectives;
